import { render, staticRenderFns } from "./GHindex.vue?vue&type=template&id=63dc533a&scoped=true&"
import script from "./GHindex.vue?vue&type=script&lang=js&"
export * from "./GHindex.vue?vue&type=script&lang=js&"
import style0 from "./GHindex.vue?vue&type=style&index=0&id=63dc533a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc533a",
  null
  
)

component.options.__file = "GHindex.vue"
export default component.exports